import { render, staticRenderFns } from "./ActionMarketingGeneralForm.vue?vue&type=template&id=fe15bdd0"
import script from "./ActionMarketingGeneralForm.vue?vue&type=script&lang=js"
export * from "./ActionMarketingGeneralForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports